import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { config } from 'src/app/config/config';
import { LoginService } from 'src/app/service/login.service';
import * as bcrypt from 'bcryptjs';

@Component({
  selector: 'app-register-email',
  templateUrl: './register-email.component.html',
  styleUrls: ['./register-email.component.css']
})
export class RegisterEmailComponent {
  registerEmailForm: FormGroup;
  captchaURL: string;
  captchaSource: string;
  hiddenCaptcha: string;
  config: any = config;
  message: string;
  page: string = "register";
  submitButton: string = 'Submit';
  randomString: string;
  userPattern: any;
  captchaPattern: string;

  constructor(private fb: FormBuilder,
    private loginService: LoginService,
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService) {}

  get f() { return this.registerEmailForm.controls; }

  ngOnInit(): void {
    this.titleService.setTitle("Unlock Account")
    this.registerEmailForm = this.fb.group({
      emailId: [null, [Validators.required, Validators.email]],
      captcha: [null, Validators.required],
    });
    this.captchaPattern=this.config.data.captchaPattern;
    this.captchaURL = this.config.URL.captchaURL;
    this.reloadCaptcha();

  }

  onSubmit() {
    if (!this.registerEmailForm.valid) {
      return;
    }
    let loginRequest: any = {
      "emailId": this.f.emailId.value,
      "captcha": this.f.captcha.value,
      "randomString": this.randomString
    };
    this.loginService.validateEmail(this.config.URL.validateEmailURL, loginRequest).pipe(
      catchError((error: any) => {
        this.message = this.config.failureResponse.login["SERVICE_UNAVAILABLE"];
        this.reset();
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.message) {
        let str = response.message;
        let encryptedMessage = bcrypt.hashSync("SUCCESSFULL:"+this.randomString, str.substr(0, 29))
        if (encryptedMessage == response.message) {
          localStorage.setItem('username', this.f.emailId.value);
          this.router.navigate(['/login/otp'], { "queryParams": { 'page': this.page, 'registerToken' : response.data[0]} });
        } else {
          encryptedMessage = bcrypt.hashSync("Invalid Credentials", str.substr(0, 29))
          if (encryptedMessage == response.message) {
            this.message = this.config.failureResponse.login["Invalid Credentials"];
            this.toastr.error(this.config.failureResponse.login["Invalid Credentials"])
            this.reset();
          }
          encryptedMessage = bcrypt.hashSync("invalidCaptcha", str.substr(0, 29))
          if (encryptedMessage == response.message) {
            this.message = this.config.failureResponse.login["invalidCaptcha"];
            this.toastr.error(this.config.failureResponse.login["invalidCaptcha"])
            this.reset();
          }
          else {
            // this.message = this.config.failureResponse.login["invalidCaptcha"];
            this.toastr.error(this.config.failureResponse.login["invalidCaptcha"])
            this.reset();
          }
        }

        // switch (response.message) {
        //   case "SUCCESSFULL": {
        //     localStorage.setItem('username', this.f.username.value);
        //     localStorage.setItem('salt', response.data[0].salt);
        //     this.router.navigate(['otp'], { "queryParams": { 'page': this.page } });
        //     break;
        //   }
        //   case "invalidCred":
        //   case "invalidCaptcha": {
        //     this.message = this.config.failureResponse.login[response.message];
        //     this.reset();
        //     break;
        //   }
        //   default: {
        //     this.message = this.config.failureResponse.login["SERVICE_UNAVAILABLE"];
        //     this.reset();
        //     break;
        //   }
        // }
      }


    });
  }

  reset() {
    this.registerEmailForm.reset();
    this.reloadCaptcha();
  }

  reloadCaptcha(): void {
    this.loginService.getCaptcha(this.captchaURL).subscribe(
      (response: any) => {
        this.captchaSource = response.data[0].captchaImage;
        this.randomString = response.data[0].randomString;
      }
    );
  }
}
